module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionSy.c051d728.png";